import React from "react";
import CasinoFilters from "./CasinoFilters";

const CasinoHeader = ({ categoryProps, searchProps, dropdownProps }) => {
  const { isMobile } = categoryProps;
  return (
    <>
      <div className="casino-container-heading">
        <div className="casino-container-title">
          <svg
            width="27"
            height="27"
            viewBox="0 0 27 27"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="me-1"
          >
            <g clip-path="url(#clip0_0_72)">
              <path
                d="M26.4621 5.80078C26.7891 5.55293 27 5.16797 27 4.725C27 3.98145 26.3936 3.375 25.65 3.375C24.9064 3.375 24.3 3.98145 24.3 4.725C24.3 5.1627 24.5162 5.55293 24.8379 5.80078V14.175H19.9758V18.4939H25.3758V18.3357C26.1668 18.0141 26.7258 17.2441 26.7258 16.3371C26.7258 15.9627 26.6203 15.6199 26.4568 15.3141V5.80078H26.4621ZM3.23789 9.31289C3.7916 9.31289 4.17129 9.40781 4.85684 9.31289C4.85684 9.31289 2.68945 10.7525 2.68945 12.5508H5.4C5.4 12.5508 5.40527 9.5502 7.01895 7.68867L6.48105 7.15078C6.48105 7.15078 5.4 7.68867 4.31895 7.15078C4.31895 7.15078 3.23789 7.15078 2.15684 7.68867V7.15078H1.61895V10.3887H2.16211C2.16211 10.3939 2.16211 9.31289 3.23789 9.31289ZM10.8 9.31289C11.3537 9.31289 11.7334 9.40781 12.4189 9.31289C12.4189 9.31289 10.2516 10.7525 10.2516 12.5508H12.9621C12.9621 12.5508 12.9674 9.5502 14.5811 7.68867L14.0432 7.15078C14.0432 7.15078 12.9621 7.68867 11.8811 7.15078C11.8811 7.15078 10.8 7.15078 9.71895 7.68867V7.15078H9.18106V10.3887H9.71895C9.71895 10.3939 9.71895 9.31289 10.8 9.31289ZM20.5189 3.91289V2.83711H13.9746C13.7268 1.75605 12.767 0.949219 11.6068 0.949219C10.4467 0.949219 9.49219 1.75605 9.24434 2.83711H2.7V3.91816H0V26.0561H23.7621V3.91289H20.5189ZM8.63789 6.075H15.1189V13.6371H8.63789V6.075ZM1.08105 6.075H7.56211V13.6371H1.08105V6.075ZM20.5189 23.3561H2.7V19.575H20.5189V23.3561ZM22.6811 13.6371H16.2V6.075H22.6811V13.6371ZM18.3621 9.31289C18.9158 9.31289 19.2955 9.40781 19.9811 9.31289C19.9811 9.31289 17.8137 10.7525 17.8137 12.5508H20.5242C20.5242 12.5508 20.5295 9.5502 22.1432 7.68867L21.6053 7.15078C21.6053 7.15078 20.5242 7.68867 19.4432 7.15078C19.4432 7.15078 18.3621 7.15078 17.2811 7.68867V7.15078H16.7432V10.3887H17.2811C17.2811 10.3939 17.2811 9.31289 18.3621 9.31289Z"
                fill="#00EC66"
              ></path>
            </g>
            <defs>
              <clipPath id="clip0_0_72">
                <rect width="27" height="27" fill="white"></rect>
              </clipPath>
            </defs>
          </svg>
          <div className="casino-name">
            <span className="casino-brand">BET FRENZY </span>
            <span className="casino-casino">
              {window.location.href.split("/")[3].includes("live")
                ? "LIVE CASINO"
                : "CASINO"}
            </span>
          </div>
        </div>

        {/* Desktop: Filters inside heading */}
        {!isMobile && (
          <CasinoFilters
            categoryProps={categoryProps}
            searchProps={searchProps}
            dropdownProps={dropdownProps}
          />
        )}
      </div>

      {/* Mobile: Filters outside heading */}
      {isMobile && (
        <CasinoFilters
          categoryProps={categoryProps}
          searchProps={searchProps}
          dropdownProps={dropdownProps}
        />
      )}
    </>
  );
};

export default CasinoHeader;
